export const ORDER_SLICE_NAME = 'gygOrder'

export const GET_ORDER_BY_USER_ID_ACTION = `${ORDER_SLICE_NAME}/getOrderByUserId`
export const GET_ORDER_BY_ORDER_ID_ACTION = `${ORDER_SLICE_NAME}/getOrderByOrderId`
export const REFUND_PAYMENT_ACTION = `${ORDER_SLICE_NAME}/refundOrder`
